import styled from "styled-components";

export const WrapperStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .top-liner {
    width: 100%;
    background-color: ${({ theme }) => theme.bg.secondary};
    border-radius: 0.35rem;
    height: 0.9rem;
  }
  .top-content {
    width: 100%;
    background-color: ${({ theme }) => theme.bg.prim_400};
    display: flex;
    justify-content: center;
    align-items: center;

    .info {
      padding: 2rem;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      @media (max-width: ${({ theme }) => theme.screen.mobile}) {
        padding: 2rem 0.2rem;
        min-width: 100%;
      }
    }

    img {
      width: 12rem;
    }
  }
`;

export const AddressWrapper = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.8rem;

  @media (max-width: ${({ theme }) => theme.screen.mobile}) {
    padding: 2rem 0.5rem;
  }

  .address-top-title {
    font-size: 1.3rem;
    color: ${({ theme }) => theme.text.primary};
    font-weight: 700;

    @media (max-width: ${({ theme }) => theme.screen.mobile}) {
      font-size: 1.1rem;
    }
  }
  .addresses {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    justify-content: space-between;
  }

  .address {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-width: 30%;

    @media (max-width: ${({ theme }) => theme.screen.mobile}) {
      max-width: 47%;
    }
  }

  .address-title {
    color: ${({ theme }) => theme.text.prim_100};
    font-size: 1.1rem;
    font-weight: 600;
    border-bottom: 2px solid ${({ theme }) => theme.border.input};
    padding-bottom: 0.25rem;

    @media (max-width: ${({ theme }) => theme.screen.mobile}) {
      font-size: 1rem;
    }
  }

  .address-details {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .detail {
    font-size: 0.85rem;
    font-weight: 700;
    color: ${({ theme }) => theme.text.prim_100};
    word-break: break-all;

    span {
      font-weight: 500;
    }
  }
`;

export const RequestTableWrapper = styled.div`
  width: 100%;
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: auto;

  @media (max-width: ${({ theme }) => theme.screen.mobile}) {
    align-items: flex-start;
    padding: 2rem 0.5rem;
  }

  table {
    border-collapse: collapse;
    width: 100%;
    min-width: 50px;
    max-width: 100%;
  }

  thead {
    tr {
      background-color: ${({ theme }) => theme.bg.secondary};
    }
  }

  th {
    color: ${({ theme }) => theme.text.prim_500};
    font-size: 0.85rem;
    font-weight: 600;
    padding: 0.75rem;
    text-align: left;
  }

  tbody {
    tr {
      border-bottom: 1px solid ${({ theme }) => theme.border.light};
    }

    td {
      color: ${({ theme }) => theme.text.prim_100};
      font-size: 0.85rem;
      font-weight: 500;
      padding: 1rem 0rem;
      vertical-align: top;
      word-break: break-all;
    }
  }

  input,
  textarea {
    color: ${({ theme }) => theme.text.prim_100};
    padding: 0.5rem;
    width: 6.5rem;
    border: transparent;
    box-shadow: ${({ theme }) => theme.shadow.shad_100};
    border-radius: 0.2rem;
    resize: none;

    :focus {
      outline: none;
      border: ${({ theme }) => theme.bg.secondary};
      box-shadow: ${({ theme }) => theme.shadow.drag_over};
    }
  }

  .other-wrapper{
    width: 100%;
    .other-container {
      width: 100%;
      display: flex;
      justify-content: flex-start;
    }
    .other-action {
      margin-top: 10px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 40px
    }
  }

  .account-container {
    width: 100%;
    display: flex;
    gap: 2rem;
    margin-top: 2rem;
    padding-top: 2rem;
    border-top: 1px solid ${({ theme }) => theme.border.light};
    flex-wrap: wrap;
  }

  .counter-options {
    width: 20rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .account-details {
    width: 20rem;
    display: flex;
    flex-direction: column;
    gap: 2.4rem;
    margin-top: 0.5rem;

    @media (max-width: ${({ theme }) => theme.screen.mobile}) {
      width: 100%;
    }

    .account-detail {
      display: flex;
      flex-direction: column;
      gap: 0.35rem;
      min-height: 3.25rem;

      h4 {
        font-size: 0.85rem;
        color: ${({ theme }) => theme.text.primary};
        font-weight: 600;
        width: 6.5rem;
      }
    }
  }

  .viewing {
    margin-top: 1rem;
    gap: 1.2rem;
  }

  .other-details {
    width: 17rem;
    display: flex;
    flex-direction: column;
    gap: 1.1rem;
    margin-top: 1rem;
    margin-left: auto;

    .quote-detail {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      h4 {
        font-size: 0.85rem;
        color: ${({ theme }) => theme.text.primary};
        font-weight: 600;
        border-bottom: 1px solid ${({ theme }) => theme.border.input};
        width: 6.5rem;
        padding: 0 0.5rem;
      }
    }
  }

  h3 {
    font-size: 0.85rem;
    color: ${({ theme }) => theme.text.prim_100};
    font-weight: 600;
  }
`;
